import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMutation } from '@tanstack/react-query';
import type { FC } from 'react';

import GoogleLogo from '@/assets/flat-color-icons--google.svg';
import {
  EnumAccountType,
  getGoogleAuth,
  getLinkedInAuth,
} from '@/services/auth/auth';

import Button from '../../Button';
import DividerWithText from '../../DividerWithText';
import type { AuthPagesProps } from '../AuthDialog';
import AuthDialogTitleMoveToLogIn from '../AuthDialogTitles/AuthDialogTitleMoveToLogIn';
import { AuthPageEnum } from '../AuthEnum';

const SignUpProvidersAuth: FC<AuthPagesProps> = ({
  setCurrentAuthPage,
  onSuccess,
  isLoginButtonHidden,
  googleCallbackUrl,
}) => {
  const { mutate } = useMutation({
    mutationFn: getGoogleAuth,
    mutationKey: ['google-auth'],
    onSuccess: ({ authorizationUrl }) => {
      window.location.href = authorizationUrl;
      onSuccess?.();
    },
  });
  const { mutate: mutateLinkedIn } = useMutation({
    mutationFn: getLinkedInAuth,
    mutationKey: ['linkedin-auth'],
    onSuccess: ({ authorizationUrl }) => {
      window.open(authorizationUrl);
      onSuccess?.();
    },
  });
  const iconSize = 20;
  return (
    <div className="flex w-full flex-col gap-8">
      <AuthDialogTitleMoveToLogIn
        setCurrentAuthPage={setCurrentAuthPage}
        isLogInButtonHidden={isLoginButtonHidden}
      />
      <div className="flex flex-col gap-4">
        <Button
          variant="candidate-secondary"
          className="w-full text-neutral-1000"
          onClick={() =>
            mutate({
              accountType: EnumAccountType.CANDIDATE,
              callbackUrl: googleCallbackUrl,
            })
          }
        >
          <GoogleLogo
            style={{ width: `${iconSize}px`, height: `${iconSize}px` }}
          />
          Sign up with Google
        </Button>
        <Button
          variant="candidate-secondary"
          className="w-full text-neutral-1000"
          onClick={() =>
            mutateLinkedIn({ accountType: EnumAccountType.CANDIDATE })
          }
        >
          <FontAwesomeIcon
            icon={faLinkedin}
            className="text-xl text-[#0a66c2]"
          />
          Sign up with LinkedIn
        </Button>
        <DividerWithText variant="primaryDark">or</DividerWithText>
        <Button
          variant="jbPrimary"
          prefixIcon="material-symbols:mail"
          className="w-full"
          onClick={() => setCurrentAuthPage(AuthPageEnum.SIGNUP_EMAIL)}
        >
          Sign up with email
        </Button>
      </div>
    </div>
  );
};

export default SignUpProvidersAuth;
